import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
export class EditLeverantorsorderradCommand extends BasicCommand<EditLeverantorsorderradCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<EditLeverantorsorderradCommand>;

    leverantorsorderradId: number;
    handelssortimentsgrupp: number;
    kvantitet: number;
    periodTom: string;
    periodFrom: string;
    egenBefraktning: boolean;
    mattslag: string;

    constructor(leverantorsorderradId: number) {
        super("EditLeverantorsorderradCommand", "leverantorsorderrad", CommandType.Replace);
        this.leverantorsorderradId = leverantorsorderradId;
    }
}
